import script from "./HomeTest.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeTest.vue?vue&type=script&setup=true&lang=js"

import "./HomeTest.vue?vue&type=style&index=0&id=00f6f273&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00f6f273"]])

export default __exports__